import { createRoot } from 'react-dom/client'
import App from './components/App'
import { ConfigProvider, type WidgetConfig } from './components/ConfigContext'

for (const container of document.querySelectorAll<HTMLElement>(
  '[data-events-list-config]'
)) {
  const configJSON = container.dataset.eventsListConfig
  if (!configJSON) {
    console.warn('Missing data-events-list-config attribute')
    continue
  }
  const config = JSON.parse(configJSON) as WidgetConfig

  const reactRoot = createRoot(container)
  reactRoot.render(
    <ConfigProvider value={config}>
      <App />
    </ConfigProvider>
  )
}
